// Detects Stripe redirect return (?payment=success) and adds the tile
// Tile data is read from localStorage to avoid the 5000-char URL limit
import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';

const PENDING_TILE_KEY = 'pending_tile_purchase';

export function useStripeReturn() {
  const { addTile } = useAppContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('payment');

    if (status === 'success') {
      try {
        const raw = localStorage.getItem(PENDING_TILE_KEY);
        if (raw) {
          const tile = JSON.parse(raw);
          addTile(tile);
          localStorage.removeItem(PENDING_TILE_KEY);
        }
      } catch (e) {
        console.error('Failed to restore tile from localStorage', e);
      }
      // Clean the URL
      const clean = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', clean);
    }

    if (status === 'cancelled') {
      // Clean the URL, leave pending tile in storage so user can retry
      const clean = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', clean);
    }
  }, []);
}